<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <div class="div-query-banner">
            <a-form-item label="工号">
              <a-input v-model="queryParam.managerUserCode" placeholder="请输入行政人员姓名" />
            </a-form-item>
            <a-form-item label="所属区域">
              <j-dict-select-tag
                v-model="queryParam.managerAreaCode"
                placeholder="请输入选择反馈项目"
                dictCode="administration_feedback_area"
              ></j-dict-select-tag>
            </a-form-item>
            <a-form-item label="行政人员姓名">
              <a-input v-model="queryParam.username" placeholder="请输入行政人员姓名"></a-input>
            </a-form-item>
            <a-form-item label="行政人员电话">
              <a-input v-model="queryParam.userphone" placeholder="请输入行政人员电话"></a-input>
            </a-form-item>
            <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
            <a-button
              class="query-banner-btn"
              type="primary"
              @click="searchReset"
              icon="reload"
              style="margin-left: 8px"
              >重置</a-button
            >
            <!-- <a @click="handleToggleSearch" class="toggle-a">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
          </div>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('行政人员和所属区域对应的表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <p slot="statusSlot" slot-scope="text">
          <span class="color-red" v-if="text === 0">启用</span>
          <span class="color-green" v-else>禁用</span>
        </p>
        <div slot="weComNotices" slot-scope="text, record">
          <a-switch
            :checked="record.weComNotices === '1' ? true : false"
            @change="handleWeComNoticesChange($event, record)"
          />
        </div>
        <p slot="action" slot-scope="text, record">
          <a type="primary" @click="handleEnableDisable(record)">{{ record.status === 0 ? '禁用' : '启用' }}</a>
          <a-divider type="vertical" />
          <a type="primary" @click="handleEdit(record)">修改</a>
        </p>
      </a-table>
    </div>

    <feedbackManager-modal ref="modalForm" @ok="modalFormOk"></feedbackManager-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import FeedbackManagerModal from './modules/FeedbackManagerModal'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import { feedbackManagerFbUserDelflag, updateWeComNotices } from '@api/api.js'
import { deleteAction } from '@/api/manage'

export default {
  name: 'FeedbackManagerList',
  mixins: [JeecgListMixin],
  components: {
    FeedbackManagerModal,
  },
  data() {
    return {
      description: '行政人员和所属区域对应的表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '区域',
          align: 'center',
          dataIndex: 'managerAreaCode_dictText',
        },
        {
          title: '账号',
          align: 'center',
          dataIndex: 'managerUserCode',
        },
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'username',
        },
        {
          title: '联系方式',
          align: 'center',
          dataIndex: 'userphone',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusSlot' },
        },
        {
          title: '微信通知',
          align: 'center',
          dataIndex: 'weComNotices',
          scopedSlots: { customRender: 'weComNotices' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/administration.base/feedbackManager/list',
        delete: '/administration.base/feedbackManager/delete',
        deleteBatch: '/administration.base/feedbackManager/deleteBatch',
        exportXlsUrl: '/administration.base/feedbackManager/exportXls',
        importExcelUrl: 'administration.base/feedbackManager/importExcel',
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    handleEnableDisable(record) {
      feedbackManagerFbUserDelflag({ id: record.id }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.loadData()
          return
        }
        this.$message.error(res.message)
      })
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        this.$antdConfirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true
            deleteAction(that.url.deleteBatch, { id: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },
    handleWeComNoticesChange(checked, datas) {
      let formData = {
        weComNotices: checked ? '1' : '0',
        id: datas.id,
      }
      const hiden = this.$message.loading('正在保存修改')
      updateWeComNotices(formData)
        .then((res) => {
          if (res.success) {
            this.$set(datas, 'weComNotices', checked ? '1' : '0')
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          hiden()
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.color-green {
  color: red;
}
.color-red {
  color: green;
}
.margin-left-btn {
  margin-left: 10px;
}
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(n) {
    width: 300px;
  }
  & > *:nth-child(n + 2) {
    margin-left: 15px;
  }
  & > .query-banner-btn:nth-child(n) {
    width: 100px;
  }
  .toggle-a {
    margin-top: 9px;
    margin-left: 8px;
  }
}
</style>
